// extracted by mini-css-extract-plugin
module.exports = {"image":"Contact_image__3hxrt","text":"Contact_text__23skK","contactLink":"Contact_contactLink__2XpK1","links":"Contact_links__3ENQm","contact":"Contact_contact__1Wnkz"};